import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import Platforms from "@/pages/Platforms";
import ZenPay from "@/pages/ZenPay";
import Wallet from "@/pages/Wallet";
import Emulation from "@/pages/Emulation";
import Solutions from "@/pages/Solutions";
import Technology from "@/pages/Technology";
import Work from "@/pages/Work";
import Company from "@/pages/Company";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <div className="min-h-screen bg-[#F8FAFC] text-[#1D305B] antialiased">
        <Header />
        <main className="pt-[78px]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/platforms" element={<Platforms />} />
            <Route path="/platforms/zenpay" element={<ZenPay />} />
            <Route path="/platforms/wallet" element={<Wallet />} />
            <Route path="/platforms/emulation" element={<Emulation />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/work" element={<Work />} />
            <Route path="/company" element={<Company />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" richColors closeButton />
      </div>
    </BrowserRouter>
  );
}
